import { connect } from 'react-redux';
import { AnchorNavigation } from './anchor-navigation';

function mapStateToProps(_state, props) {
  return {
    items: props.entity.result
  };
} // FIXME: propTypes
//@ts-ignore


export var DataAnchorNavigation = connect(mapStateToProps)(AnchorNavigation);